import { render, staticRenderFns } from "./ViewTab.vue?vue&type=template&id=542f746c&scoped=true&"
import script from "./ViewTab.vue?vue&type=script&lang=js&"
export * from "./ViewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f746c",
  null
  
)

export default component.exports